
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 2.5a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4.414a1 1 0 00-.707.293L.854 15.646A.5.5 0 010 15.293V2.5zm3.5 1a.5.5 0 100 1h9a.5.5 0 000-1h-9zm0 2.5a.5.5 0 100 1h9a.5.5 0 000-1h-9zm0 2.5a.5.5 0 100 1h5a.5.5 0 100-1h-5z"}})])
          )
        }
      }
    